import React, { useEffect, useState } from 'react'
import Toast from '../../helpers/Toast';
import { GetExternalAssistancesDTO } from '../../models/Assistance/GetExternalAssistancesDTO';
import { GetPaginatedExternalAssistancesDTO } from '../../models/Assistance/GetPaginatedExternalAssistancesDTO';
import { AssistanceService } from '../../services/AssistanceService';
import TableComponent from '../TableComponent';
import { FormattedMessage, useIntl } from 'react-intl';
import ButtonComponent from '../ButtonComponent';
import ModalComponent from '../ModalComponent';

type ExternalAssistanceTableProps = {
    assistanceId: number
    reload: boolean
    isComplete: boolean
}

function ExternalAssistanceTable({ assistanceId, reload, isComplete }: ExternalAssistanceTableProps) {
    const assistanceService = new AssistanceService();
    const [data, setData] = useState<GetExternalAssistancesDTO[]>([]);
    const pageSizes: number[] = [5, 15, 30];
    const [pageSize, setPageSize] = useState<number>(pageSizes[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [goToPage, setGoToPage] = useState<number>();
    const [pageCount, setPageCount] = useState(1);

    const intl = useIntl();
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [removeLine, setRemovedLine] = useState<GetExternalAssistancesDTO>();
    const [reloaddAfterRemove, setReloadAfterRemove] = useState<boolean>(false);

    const columns = React.useMemo(
        () => [
            {
                Header: "Data",
                accessor: "dateString",
                width: 30,
            },
            {
                Header: "Artigo",
                accessor: "article",
                width: 20,
            },
            {
                Header: "Quantidade",
                accessor: "debtHoutrs",
                width: 20,
            },
            {
                Header: <FormattedMessage id="Screens.Assistances.AditionalInfo.Table.RemoveLine" />,
                accessor: " ",
                show: !isComplete,
                width: 30,
                Cell: (props: any) => {
                    return (
                        <div style={{ display: "inline-flex", height: "30px" }}>
                            <ButtonComponent
                                text={intl.formatMessage({ id: "ExternalAssistancesTableComponent.PopUp.Remove" })}
                                onClick={() => {
                                    setIsOpen(true);
                                    setRemovedLine(props.cell.row.original)
                                }} />
                        </div>
                    )
                }
            },
        ],
        [],
    );

    const fetchData = async (page: number, pageSize: number) => {
        var data: GetPaginatedExternalAssistancesDTO = {
            assistanceId: assistanceId,
            currentPage: page,
            pageSize: pageSize
        }

        setIsLoading(true);
        var response = await assistanceService.GetExternalAssistances(data);

        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }

        setData(response.items);
        setIsLoading(false);
        setPageCount(response.totalPages);
        setPageSize(pageSize);
        setCurrentPage(page);
        setGoToPage(0)
    }

    useEffect(() => {
        fetchData(currentPage, pageSize);
    }, [reload, reloaddAfterRemove])

    const Remove = async (selectedLine: any) => {
        var response = await assistanceService.RemoveExternalAssistanceFromAssistance(selectedLine.id);
        if (response.success === false) {
            Toast.Show("error", response.message);
            return
        }
        setReloadAfterRemove(!reloaddAfterRemove);

        Toast.Show("success", "Peça removida da assistência com sucesso");
    }
    return (
        <div>
            <ModalComponent IsOpen={isOpen} text={`Tem a certeza que quer remover a assistência externa com a data ${removeLine?.dateString} da assistência?`} OnClickRight={() => setIsOpen(false)} OnClickLeft={() => { setIsOpen(false); Remove(removeLine) }} title={"Remover linha da assistência"} buttonRight={"Não"} buttonLeft={"Sim"} />
            <TableComponent
                columns={columns}
                data={data}
                goToPage={goToPage}
                initialPage={currentPage}
                pageCount={pageCount}
                initialPageSize={pageSize}
                pageSizes={pageSizes}
                manualPagination={true}
                loading={isLoading}
                fetchData={fetchData}
                initialSortBy={[]}
                disableSortBy={true}
            />
        </div>
    )
}

export default ExternalAssistanceTable